import { router } from '@inertiajs/react'
import { TabPanel } from '@headlessui/react'
import type { SalesminerOpportunity } from '@/types/serializers'
import type { NavigationData } from '@/types/NavigationData'
import ActionBar from './_components/ActionBar'
import TabNavigation from '@/components/ui/TabNavigation'
import OverviewTab from './_tabs/OverviewTab.tsx'
import DeepDiveTab from './_tabs/DeepDiveTab.tsx'
import ActionsTab from './_tabs/ActionsTab.tsx'
import PageHeader from './_components/PageHeader'
import SalesminerAppLayout from "@/salesminer/layouts/SalesminerAppLayout.tsx";

interface OpportunityDetailProps {
    opportunity: SalesminerOpportunity
    navigation_data: NavigationData
    back_path: string
}


export default function OpportunityDetail({opportunity, navigation_data, back_path}: OpportunityDetailProps) {
    // Tab configuration
    const tabs = [
        {label: 'Overview', id: 'overview'},
        {label: 'Deep Dive', id: 'deepdive'},
        {label: 'Actions', id: 'actions'}
    ]

    const handleBack = () => {
        router.visit(back_path)
    }

    const handleNextOpportunity = () => {
        if (navigation_data.next_opportunity_path) {
            router.visit(navigation_data.next_opportunity_path)
        }
    }

    const handleRelevant = () => {
        console.log('Mark as relevant:', opportunity.id)
    }

    const handleStar = () => {
        console.log('Toggle star:', opportunity.id)
    }

    const handleDiscard = () => {
        console.log('Mark as discarded:', opportunity.id)
    }

    return (<SalesminerAppLayout>
            <div className="p-6">
                <div className="max-w-[1400px] mx-auto">
                    <div className="mb-6">
                        <PageHeader
                            opportunity={opportunity}
                            onBack={handleBack}
                            onNextOpportunity={handleNextOpportunity}
                            navigationData={navigation_data}
                        />

                        <ActionBar
                            opportunity={opportunity}
                            onRelevant={handleRelevant}
                            onStar={handleStar}
                            onDiscard={handleDiscard}
                        />

                        <TabNavigation tabs={tabs}>
                            <TabPanel>
                                <OverviewTab opportunity={opportunity}/>
                            </TabPanel>
                            <TabPanel>
                                <DeepDiveTab opportunity={opportunity}/>
                            </TabPanel>
                            <TabPanel>
                                <ActionsTab opportunity={opportunity}/>
                            </TabPanel>
                        </TabNavigation>
                    </div>
                </div>
            </div>
        </SalesminerAppLayout>
    )
}